<template>
  <img
    v-if="!tag.meta.affix"
    :src="closeImage"
    style="vertical-align: middle;"
    @click.prevent.stop="closeSelectedTag(tag)"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  />
</template>

<script>
export default {
  name: 'CloseIcon',
  props: [
    'tag',
  ],
  data() {
    return {
      closeImage: '',
      isMouseEnter: false,
    };
  },
  mounted() {
    this.changeCloseImage();
  },
  computed: {
    isActive() {
      return this.tag && this.tag.path === this.$route.path;
    },
  },
  watch: {
    $route() {
      this.changeCloseImage();
    },
  },
  methods: {
    handleMouseEnter() {
      this.isMouseEnter = true;
      this.closeImage = this.isActive ? require('@/assets/close_white_in.png') : require('@/assets/close_gray_in.png');
    },
    handleMouseLeave() {
      this.isMouseEnter = false;
      this.closeImage = this.isActive ? require('@/assets/close_white_out.png') : require('@/assets/close_gray_out.png');
    },
    closeSelectedTag() {
      this.$emit('close', this.tag);
    },
    changeCloseImage() {
      if (this.isActive) {
        if (this.isMouseEnter) {
          this.closeImage = require('@/assets/close_white_in.png');
        } else {
          this.closeImage = require('@/assets/close_white_out.png');
        }
      } else if (this.isMouseEnter) {
        this.closeImage = require('@/assets/close_gray_in.png');
      } else {
        this.closeImage = require('@/assets/close_gray_out.png');
      }
    },
  },
};
</script>

<style scoped>

</style>
